import * as Sentry from '@sentry/browser';
import i18next from 'i18next';
import React from 'react';
import { connect } from 'react-redux';

import Row from '@Components/layout/Row';
import Typography from '@Components/Typography';
import config from '@Config/config';
import { Messages } from '@Config/messages';
import { RootState } from '@Store/reducers';

import styles from './ErrorWrapper.module.scss';

export interface ErrorWrapperProps {}

const ErrorWrapper = <BaseProps extends {}>(
  WrappedComponent: React.ComponentType<BaseProps>,
  fallbackText?: Messages,
) => {
  type HocState = {
    readonly error: Error | null | undefined;
  };

  class Hoc extends React.Component<ErrorWrapperProps, HocState> {
    // eslint-disable-next-line react/state-in-constructor
    readonly state: HocState = {
      error: undefined,
    };

    componentDidCatch(error: Error | null) {
      this.setState({ error: error || new Error() });
      if (config.SENTRY_DSN) {
        Sentry.captureException(error);
      }
    }

    render() {
      const { ...restProps } = this.props;
      const { error } = this.state;

      return error ? (
        <Row alignCenter justifyCenter className={styles.fallback}>
          <Typography msg={i18next.t(fallbackText || Messages.errorOccurred)} tag="h4" />
        </Row>
      ) : (
        <WrappedComponent {...(restProps as BaseProps)} />
      );
    }
  }

  return connect<ErrorWrapperProps, null, {}, RootState>(null)(Hoc);
};

export default ErrorWrapper;
